import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonGroup, Grid } from '@mui/material';
import patientViewSx from './PatientView.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import Profile from './Profile';
import { actions } from './PatientView.redux';
import classnames from 'classnames';
import PatientReports from './PatientReports';
import PatientCharts from './PatientCharts';
import { actions as fileActions } from 'components/FileManager/FileManager.redux';
import FileManager from 'components/FileManager';
import { useParams } from 'react-router-dom';



const PatientView = () => {

	const tab      = useSelector(state => state.patientView.tab),
		  dispatch = useDispatch(),
		  resetAll = () => dispatch(actions.resetAll()),
		  profile  = useSelector(state => state.patientView.profile);

	const theme = useTheme();
	const sx = patientViewSx(theme);


	const { patient_id } = useParams();
	const openFileManager = () => dispatch(fileActions.setState({ open: true, page: 'patient' }));


	const handleTabChange = useCallback((e) => {
		if(tab === e.currentTarget.name) {
			return false;
		}

		dispatch(actions.setState({ tab: e.currentTarget.name }));
	}, [ dispatch, tab ]);



	useEffect(() => {
		return () => {
			resetAll();
		};
	}, [ dispatch ]);


	return (
		<Grid container spacing={4}>
			<Grid size={{ xs: 12, sm: 12, lg: 4, xl: 3 }}>
				<Profile />
			</Grid>

			<Grid size={{ xs: 12, sm: 12, lg: 8, xl: 9 }}>
				<Box sx={sx.buttonGroupContainer}>
					<ButtonGroup fullWidth variant="contained">

						<Button
							size="large"
							name="charts"
							onClick={handleTabChange}
							sx={tab === 'charts'
								? sx.visitsActive
								: sx.visitsInactive}
						>
							Charts
						</Button>

						<Button
							size="large"
							name="reports"
							onClick={handleTabChange}
							sx={tab === 'reports'
								? sx.reportsActive
								: sx.reportsInactive}
						>
							Reports
						</Button>

						<Button
							size="large"
							name="files"
							onClick={openFileManager}
						>
							Files
						</Button>
					</ButtonGroup>
				</Box>

				{tab === 'charts' && <PatientCharts />}
				{tab === 'reports' && <PatientReports />}

				<FileManager
					selectActions={[]}
					patient_id={patient_id}
					client_id={profile?.client_id}
					defaultPage="patient"
				/>

			</Grid>
		</Grid>
	);

};



export default PatientView;
